/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #f9f9f9;
  min-height: 100vh;
  overflow: hidden;
`;

export const TableContainer = styled.div`
  margin-top: 20px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const UserHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;

export const Title = styled.span`
  align-self: flex-start;
  font-family: BiotifSemiBold;
  font-size: 28px;
  padding-bottom: 10px;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 246px;
  height: 45px;
  background: ${({ selected }) =>
    selected ? '#fff 0% 0% no-repeat padding-box' : '#c9cbd3 0% 0% no-repeat padding-box'};
  border-radius: 4px 4px 0px 0px;
  font: normal normal normal 16px/24px Biotif;
  font-weight: 600;
  cursor: pointer;
`;

export const TabTitle = styled.div`
  font-size: 14px;
  text-transform: capitalize;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  height: 80vh;
  align-items: flex-start;
`;

export const FeatureToggleLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
  padding: 30px;
  width: 100%;
  border-bottom: 1px solid #f3f4f8;
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  width: 100%;
  background-color: #fff;
  height: 80vh;
`;

export const LeaveHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const LeaveContainer = styled.div`
  margin-left: 20px;
  width: 95%;
`;
export const CompanyContainer = styled.div`
  margin-left: 20px;
  width: 95%;
`;
export const CompanyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const CellSpan = styled.span`
  color: #4948ac;

  &:hover {
    cursor: pointer;

    color: #2dcaff;
  }
`;
